(() => {
  if (window.cbjSizePopupsReady || !window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;
  window.cbjSizePopupsReady = true;
  let dialog, opener;
  function makeDialog() {
    if (dialog && dialog.isConnected) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'cbj-size-dialog';
    dialog.setAttribute('aria-labelledby', 'cbj-size-dialog-title');
    dialog.innerHTML = '<div class="cbj-size-dialog__header"><h2 id="cbj-size-dialog-title"></h2><button type="button" data-cbj-fit-close></button></div><div class="cbj-size-dialog__content"></div>';
    document.body.append(dialog);
    dialog.querySelector('[data-cbj-fit-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('cbj-size-dialog-open');
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    });
    return dialog;
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-cbj-fit-open]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const guide = link.closest('[data-cbj-fit-guide]');
    const location = link.parentElement.querySelector('template[data-cbj-fit-location]');
    const measuring = guide && guide.querySelector('template[data-cbj-fit-measuring]');
    if (!location || !measuring) return;
    event.preventDefault();
    const panel = makeDialog();
    opener = link;
    panel.querySelector('h2').textContent = link.dataset.dialogTitle;
    const close = panel.querySelector('[data-cbj-fit-close]');
    close.textContent = guide.dataset.closeLabel + ' ×';
    close.setAttribute('aria-label', guide.dataset.closeLabel);
    const content = panel.querySelector('.cbj-size-dialog__content');
    content.replaceChildren(location.content.cloneNode(true), measuring.content.cloneNode(true));
    if (!panel.open) panel.showModal();
    document.documentElement.classList.add('cbj-size-dialog-open');
    content.scrollTop = 0;
    close.focus({ preventScroll: true });
  });
})();
